import React, { useMemo, useState } from 'react';
import { Divider, Form, Input, Select, Typography } from 'antd';
import useAllCustomers from '../../Customers/useAllCustomers';

const { TextArea } = Input;
const { Text } = Typography;

const ContactStep = ({ data, onChange, isEmbedded = false }) => {
    const { allCustomersAsArray } = useAllCustomers();
    const [form] = Form.useForm();

    const selectedCustomer = useMemo(() => {
        return allCustomersAsArray.find((customer) => customer.customerId === data.customerId);
    }, [allCustomersAsArray, data.customerId]);

    const handleCustomerSelect = (value) => {
        const customer = allCustomersAsArray.find((customer) => customer.customerId === value);
        onChange(customer);
        form.setFieldsValue({
            name: customer.name,
            email: customer.email,
            phone: customer.phone,
            company: customer.company,
            specialRequests: customer.specialRequests,
        });
    }

    return (
        <>
            {!isEmbedded && (
                <div className="mb-4">
                    <Text type="secondary">
                        Select an existing customer or enter details below to create a new one.
                    </Text>
                    <div className="d-flex align-items-center mt-2">
                        <Select
                            style={{ width: '100%' }}
                            placeholder="Select a customer"
                            value={selectedCustomer?.customerId}
                            onChange={handleCustomerSelect}
                            options={allCustomersAsArray?.map((customer) => ({
                                label: customer.name,
                                value: customer.customerId,
                            }) || [])}
                            allowClear
                        />
                    </div>
                    <Divider />
                </div>
            )}
            <Form
                form={form}
                layout="vertical"
                className="contact-form"
                style={{ maxWidth: '100%' }}
                initialValues={data}
                onValuesChange={(_, allValues) => onChange(allValues)}
            >
                <Form.Item
                    label="Name"
                    name="name"
                    rules={[{ required: true, message: 'Please enter your name' }]}
                >
                    <Input placeholder="Enter your name" size="large" />
                </Form.Item>

                <Form.Item
                    label="Email"
                    name="email"
                    rules={[
                        { required: true, message: 'Please enter your email' },
                        { type: 'email', message: 'Please enter a valid email' }
                    ]}
                >
                    <Input placeholder="Enter your email" size="large" />
                </Form.Item>

                <Form.Item
                    label="Phone"
                    name="phone"
                    rules={[{ required: true, message: 'Please enter your phone number' }]}
                >
                    <Input placeholder="Enter your phone number" size="large" />
                </Form.Item>

                <Form.Item
                    label="Company Name"
                    name="company"
                >
                    <Input placeholder="Enter your company name (optional)" size="large" />
                </Form.Item>

                <Form.Item
                    label="Special Requests"
                    name="specialRequests"
                >
                    <TextArea
                        rows={4}
                        placeholder="Enter any special requests (optional)"
                        size="large"
                    />
                </Form.Item>
            </Form>
        </>
    );
};

export default ContactStep; 